export enum LayoutColumnComponents {
  DEV_TOOLS = -1,
  LAYOUT_CONTROLS = 0,
  ORDER_LIST = 1,
  INSTRUCTION_LIST = 2,
  FILE_VIEWER = 3,
  MAP = 4,
  APP = 5,
  CUSTOMER = 6,
  PRODUCTION_STATEMENT = 7,
  PURCHASING = 8,
  BILLING = 9,
  INSTRUCTION_FINDER = 10,
  INVOICE = 11,
  QUOTE = 12
}
